import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';

@Component({
  selector: 'app-config-default-image',
  templateUrl: './config-default-image.component.html',
  styleUrls: ['./config-default-image.component.scss']
})
export class ConfigDefaultImageComponent implements OnInit {
  isChange: boolean = false;
  signConfig: any = [
    {
      signatureComponent: "issuedTo",
      isDefault: false,
      isRequire: false
    },
    {
      signatureComponent: "phone",
      isDefault: false,
      isRequire: false
    },
    {
      signatureComponent: "dateTime",
      isDefault: false,
      isRequire: false
    },
    {
      signatureComponent: "address",
      isDefault: false,
      isRequire: false
    },
    {
      signatureComponent: "tick",
      isDefault: false,
      isRequire: false
    },
    {
      signatureComponent: "position",
      isDefault: false,
      isRequire: false
    },
    {
      signatureComponent: "signatureImage",
      isDefault: false,
      isRequire: false
    },
    {
      signatureComponent: "email",
      isDefault: false,
      isRequire: false
    },
  ];
  constructor(
    public diaLogRef: MatDialogRef<ConfigDefaultImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private message: Message,
    private dialog: MatDialog,
    private toastr: ToastrService
  ) {
    diaLogRef.disableClose = true;
    if(data){
      this.signConfig.forEach(ele => {
        data.forEach(ele2 => {
          if(ele.signatureComponent == ele2.signatureComponent){
            ele.isDefault = ele2.isDefault;
            ele.isRequire = ele2.isRequire;
          }
        });
      });
    }
  }

  ngOnInit() {
    
  }

  ngOnDestroy(): void {

  }

  getName(signatureComponent: any){
    
    switch(signatureComponent){
      case 'issuedTo':
        return this.message.getMessage('enterprise_contract.panel_document_view.table_signing_flow.detail_content.issued_to');
      case 'phone':
        return this.message.getMessage('headertable.phone');
      case 'dateTime':
        return this.message.getMessage('enterprise_contract.image_signing.no_image.signing_time');
      case 'address':
        return this.message.getMessage('headertable.address');
      case 'tick':
        return this.message.getMessage('enterprise_contract.image_signing.no_image.green_tick');
      case 'position':
        return this.message.getMessage('enterprise_contract.image_signing.no_image.position');
      case 'signatureImage':
        return this.message.getMessage('enterprise_contract.image_signing.no_image.signatureImage');
      case 'email':
        return this.message.getMessage('config_notification.email');
    }
  }

  cancel(){
    if(this.isChange){
      const dialogRef2 = this.dialog.open(WarningComponent, {
        width: "365px",
        data: this.message.getMessage('digital-certificate-default.dialog_add.confirm_close')
      })
      dialogRef2.afterClosed().subscribe(res => {
        if(res){
          this.diaLogRef.close();
        }
      })
    } else {
      this.diaLogRef.close()
    }
  }

  save(){
    this.toastr.success(this.message.getMessage('digital-certificate-default.dialog_add.done_success'))
    this.diaLogRef.close(this.signConfig);
  }

  changeValue(item: any){
    if(!item.isDefault && item.isRequire){
      item.isRequire = false;
    }
    this.isChange = true;
  }
}
